import { lazy } from "react";

const routes = [
  {
    path: "/settings/product-categories",
    element: lazy(() => import("../../pages/Settings/ProductCategories")),
  },
];

export default routes;
